var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{},[(_vm.idenCode == 1)?_c('div',[_c('introduceVue'),_c('information'),_c('missionVue'),_c('CertificationVue')],1):_vm._e(),(_vm.idenCode == 3)?_c('div',[_c('informationIndex')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }